import { Navbar, Footer } from "@/components/Navbar";
import { FileText } from "lucide-react";

const updated = "Junho de 2026";

export default function Termos() {
  return (
    <div className="min-h-screen bg-[#fafaf8]">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-[#1b5e3f] bg-[#e8f0ec] px-3 py-1.5 rounded-full"><FileText className="w-3.5 h-3.5" /> Termos</span>
        <h1 className="font-head text-4xl font-bold text-[#1c1917] mt-5">Termos de Serviço</h1>
        <p className="text-[#78716c] mt-2">Última atualização: {updated}</p>

        <div className="mt-8 space-y-6 text-[#44403c] leading-relaxed">
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">1. Aceitação</h2>
            <p>Ao criar uma conta ou utilizar o Portal Brasil Portugal ("Plataforma"), você concorda com estes Termos de Serviço e com a nossa Política de Privacidade.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">2. A Plataforma</h2>
            <p>O Portal Brasil Portugal conecta profissionais, empresas, imóveis e serviços entre o Brasil e Portugal. Atuamos como intermediário: não somos parte nas negociações, contratações ou contratos de arrendamento firmados entre os usuários.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">3. Cadastro e responsabilidades do usuário</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Fornecer informações verdadeiras, atualizadas e completas.</li>
              <li>Manter a confidencialidade das credenciais de acesso.</li>
              <li>Para anunciar imóveis, enviar a documentação obrigatória (CPF, autorização de residência ou registo na ordem dos mediadores, contrato/declaração do imóvel e selfie de verificação).</li>
              <li>Não publicar conteúdo ilegal, fraudulento, ofensivo ou que viole direitos de terceiros.</li>
            </ul>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">4. Assinaturas e pagamentos</h2>
            <p>O perfil ativo no diretório depende de assinatura: promoção de lançamento de 10€ por 1 ano; ou 15€/mês. O plano de anunciante oficial é de 1200€/ano. Anúncios avulsos possuem planos próprios. Os pagamentos são processados pelo Stripe. Salvo disposição legal aplicável, os valores pagos não são reembolsáveis após a ativação do período contratado.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">5. Conteúdo e moderação</h2>
            <p>Você é responsável pelo conteúdo que publica. Reservamo-nos o direito de revisar, ocultar ou remover perfis, imóveis e anúncios que violem estes Termos, bem como suspender contas, com ou sem aviso prévio.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">6. Limitação de responsabilidade</h2>
            <p>A Plataforma é fornecida "no estado em que se encontra". Não garantimos a veracidade das informações publicadas pelos usuários nem nos responsabilizamos por danos decorrentes de negociações entre eles.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">7. Alterações</h2>
            <p>Podemos atualizar estes Termos a qualquer momento. O uso continuado da Plataforma após alterações implica concordância com a versão vigente.</p>
          </section>
          <section>
            <h2 className="font-head text-xl font-semibold text-[#1c1917]">8. Contato</h2>
            <p>Dúvidas sobre estes Termos? Utilize a página <a href="/contato" className="text-[#1b5e3f] font-semibold underline">Fale Conosco</a>.</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}
